module.exports = __webpack_public_path__ + "static/img/4962_phase_function_Paper_Points.d9141d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4962_phase_function_Paper_Points.png
// module id = Augq
// module chunks = 0